// Lightweight theme manager
export function applyTheme(theme) {
  const el = document.documentElement;
  el.setAttribute('data-theme', theme);
  // Help form controls & system UIs pick the right palette
  el.style.colorScheme = theme === 'dark' ? 'dark' : 'light';
  try { localStorage.setItem('theme', theme); } catch {}
}

export function getCurrentTheme() {
  const el = document.documentElement;
  return el.getAttribute('data-theme') || 'light';
}

export function initTheme() {
  let theme = 'light';
  try {
    const saved = localStorage.getItem('theme');
    if (saved === 'light' || saved === 'dark') {
      theme = saved;
    } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      theme = 'dark';
    }
  } catch {}
  applyTheme(theme);
  return theme;
}
